import { BOGeneralValues } from "./BOGeneralValues.model";
import { BOSubServiceDetail } from "./BOSubServiceDetail.model";

export class BOSellDetail extends BOGeneralValues{
  id?:number;
  sellId?:number;
  profesionalId?:number;
  serviceTypeId?:number;
  amount?:number;
  price?:number;
  sellDetailIdTemp?:number;
  subServicesDetails?:BOSubServiceDetail[]=[];
  serviceGroupId?:number;
  itemSaved?:boolean;
  areaId?:number;
}
